// src/services/tollService.js
import requestInstance from "./Request";
import axios from "axios";

const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/admin-api/v1`

const handleResponse = async (response) => {
    console.log("Response,", response);
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || "API request failed");
  }
  return response.json();
};

const tollService = {
  // GET: Fetch all toll
  async getTollList(params = {}) {
    try {
      const response = await requestInstance.get(`${BASE_URL}/tolls`, {
        params, // Will convert to query params like ?locationId=123
      });
      console.log("Response,", response);
      return response.data;
    } catch (error) {
      console.error("Error fetching toll list:", error);
      throw error;
    }
  },

  // Create a new toll
  async createToll(tollData) {
    try {
      const response = await requestInstance.post(`${BASE_URL}/add-toll`, tollData);
      return response.data;
    } catch (error) {
      console.error("Error creating toll:", error);
      throw error;
    }
  },

  async updateToll(tollId, updatedData) {
    try {
      const response = await requestInstance.put(`${BASE_URL}/update-toll/${tollId}`, updatedData);
      return response.data;
    } catch (error) {
      console.error("Error updating toll:", error);
      throw error;
    }
  },

  async deleteToll(tollId) {
    try {
      const response = await requestInstance.delete(`${BASE_URL}/delete-toll/${tollId}`);
      return response.data;
    } catch (error) {
      console.error("Error deleting toll:", error);
      throw error;
    }
  },
};

export default tollService;